module.exports = __webpack_public_path__ + "static/media/ms-teams.6976fa0b.svg";